import { Component } from 'react'
import { useLocation } from 'react-router-dom'
import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar'
import $ from 'jquery'
import moment from 'moment'

import CalendarToolbar from '../CalendarToolbar'
import CalendarCell from '../CalendarCell'
import MonthEvent from '../MonthEvent'
import { parseEventsForCalendar } from '../../../helpers/helpers'
import CalendarEventPopup from '../CalendarEventPopup'
import API from '../../../api/api'

const calendarLocalizer = momentLocalizer(moment)

const getBuildingIdFromLocation = (location) => {
  if (!location) {
    return null
  }

  return new URLSearchParams(location.search || '').get('building')
}

class CalendarWidgetComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      buildingId: getBuildingIdFromLocation(props.location),
      events: [],
      event: {},
      eventPopup: {
        open: false,
        target: null,
      },
    }
    this.getEvents = this.getEvents.bind(this)
    this.showPopup = this.showPopup.bind(this)
    this.hidePopup = this.hidePopup.bind(this)
    this.selectEvent = this.selectEvent.bind(this)
    this.handleOnNavigate = this.handleOnNavigate.bind(this)
  }

  componentDidMount() {
    if (!this.state.buildingId) {
      return
    }

    const start = moment().startOf('month').subtract(7, 'days').toDate()
    const end = moment().endOf('month').add(7, 'days').toDate()

    this.getEvents(start, end)

    $(window).on('resize', () => {
      this.hidePopup()
    })
  }

  getEvents(start, end) {
    if (!this.state.buildingId) {
      return
    }

    API.getTrainingsForBuilding(start.getTime(), end.getTime(), this.state.buildingId)
      .then((res) => {
        this.setState({ events: res })
      })
      .catch((error) => {
        throw new Error(error)
      })
  }

  showPopup(event, target) {
    // nested setState because first popup will render it's width and height based on event object
    // and then can properly calculate position
    this.setState({ event }, () => {
      this.setState((prevState) => ({
        ...prevState,
        eventPopup: {
          open: true,
          target: target,
        },
      }))
    })
  }

  hidePopup() {
    this.setState({
      event: {},
      eventPopup: {
        open: false,
        target: null,
      },
    })
  }

  selectEvent(event, e) {
    const target = $(e.target).closest('.ctp-event')
    this.showPopup(event, target)
  }

  handleOnNavigate(e) {
    this.hidePopup()
    const start = moment(e).startOf('month').subtract(7, 'days').toDate()
    const end = moment(e).endOf('month').add(7, 'days').toDate()
    this.getEvents(start, end)
  }

  render() {
    const { eventPopup, events } = this.state
    const trainings = parseEventsForCalendar(events)
    return (
      <div className="ctp-layout__calendar-widget ctp-layout__manager-calendar">
        <div className="ctp-calendar">
          <BigCalendar
            selectable={true}
            popup
            views={{ month: true }}
            events={trainings}
            localizer={calendarLocalizer}
            components={{
              toolbar: CalendarToolbar,
              dateCellWrapper: CalendarCell,
              month: {
                event: MonthEvent,
              },
            }}
            maxRows={99999}
            onSelectSlot={this.hidePopup}
            onSelectEvent={this.selectEvent}
            onNavigate={this.handleOnNavigate}
            defaultDate={new Date()}
            // react-big-calendar's "show more" popup overlay always renders events as
            // draggable and calls handleDragStart unconditionally (unlike its other event
            // handlers), so without the drag-and-drop addon it throws when a user drags an
            // event card inside that overlay. This widget doesn't support drag-and-drop, so
            // the handler is a no-op.
            handleDragStart={() => {}}
          />
          <CalendarEventPopup
            userRole={'public'}
            event={this.state.event}
            open={eventPopup.open}
            target={eventPopup.target}
            onEditEvent={() => {}}
            onClose={this.hidePopup}
          />
        </div>
      </div>
    )
  }
}
const CalendarWidget = (props) => {
  const location = useLocation()

  return <CalendarWidgetComponent {...props} location={location} />
}

export default CalendarWidget
